import { FC } from 'react';
// components
import BottleSizeComponent from 'components/main/BottleSize/Edit';

const EditBottleSize: FC = () => <BottleSizeComponent />;

export default EditBottleSize;
